/* VERON · Wishlist — localStorage, kein App-Abo.
   Key: veron:wishlist:v1 = ["produkt-handle", ...] */
(function () {
  'use strict';
  var KEY = 'veron:wishlist:v1';

  var LANG = (document.documentElement.lang || 'de').slice(0, 2);
  var I18N = {
    de: { added: '♥ Gemerkt.', link: 'Zur Wunschliste →', removed: 'Von der Wunschliste entfernt.', ariaAdd: 'Auf die Wunschliste', ariaRemove: 'Von der Wunschliste entfernen', remove: 'Entfernen' },
    nl: { added: '♥ Bewaard.', link: 'Naar verlanglijst →', removed: 'Van de verlanglijst verwijderd.', ariaAdd: 'Op de verlanglijst', ariaRemove: 'Van de verlanglijst verwijderen', remove: 'Verwijderen' },
    en: { added: '♥ Saved.', link: 'View wishlist →', removed: 'Removed from wishlist.', ariaAdd: 'Add to wishlist', ariaRemove: 'Remove from wishlist', remove: 'Remove' },
  };
  var TXT = I18N[LANG] || I18N.de;
  var WL_PATH = (LANG === 'de' ? '' : '/' + LANG) + '/pages/wunschliste';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('veron:wishlist:change', { detail: { count: list.length } }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.unshift(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1; // true = wurde hinzugefügt
  }

  function toast(msg, linkText, linkHref) {
    var t = document.getElementById('veron-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'veron-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = msg + (linkText ? ' <a href="' + linkHref + '">' + linkText + '</a>' : '');
    t.classList.add('is-in');
    clearTimeout(t._hide);
    t._hide = setTimeout(function () { t.classList.remove('is-in'); }, 2600);
  }

  function paintButtons(root) {
    (root || document).querySelectorAll('[data-veron-wish]').forEach(function (btn) {
      var active = has(btn.getAttribute('data-veron-wish'));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? TXT.ariaRemove : TXT.ariaAdd);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-veron-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(btn.getAttribute('data-veron-wish'));
    paintButtons();
    if (added) toast(TXT.added, TXT.link, WL_PATH);
    else toast(TXT.removed);
  });

  /* Wunschliste-Seite rendern */
  function money(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }
  function renderPage() {
    var grid = document.getElementById('veron-wishlist-grid');
    if (!grid) return;
    var empty = document.getElementById('veron-wishlist-empty');
    var handles = read();
    if (!handles.length) {
      if (empty) empty.hidden = false;
      grid.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = '';
    handles.forEach(function (h, idx) {
      fetch('/products/' + h + '.js')
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) {
          var el = document.createElement('article');
          el.className = 'veron-card';
          var img = p.featured_image
            ? '<img class="veron-card__img" loading="lazy" src="' + p.featured_image + '&width=720" alt="">'
            : '<span class="veron-card__mono">' + (p.vendor || 'V').slice(0, 2).toUpperCase() + '</span>';
          el.innerHTML =
            '<a class="veron-card__link" href="' + p.url + '">' +
              '<div class="veron-card__media veron-card__media--' + ['a','b','c','d'][idx % 4] + '">' + img + '</div>' +
              '<div class="veron-card__body">' +
                '<div class="veron-card__brand">' + (p.vendor || '') + '</div>' +
                '<div class="veron-card__name v-editorial">' + p.title + '</div>' +
                '<div class="veron-card__row"><span class="v-price">' + money(p.price) + '</span></div>' +
              '</div>' +
            '</a>' +
            '<button type="button" class="v-btn v-btn--ghost veron-card__cta" data-veron-wish="' + h + '">' + TXT.remove + '</button>';
          grid.appendChild(el);
          paintButtons(el);
        })
        .catch(function () { /* Produkt existiert nicht mehr — still entfernen */
          var list = read().filter(function (x) { return x !== h; });
          write(list);
        });
    });
  }

  document.addEventListener('veron:wishlist:change', function () {
    if (document.getElementById('veron-wishlist-grid')) renderPage();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { paintButtons(); renderPage(); });
  } else { paintButtons(); renderPage(); }
})();

/* Zaehlwerk im Kopf. Eigener Block, damit an der bestehenden Logik nichts
   angefasst wird: liest denselben Speicher und hoert auf das Ereignis, das
   write() ohnehin schon ausloest. */
(function () {
  'use strict';
  var KEY = 'veron:wishlist:v1';
  function anzahl() {
    try { return (JSON.parse(localStorage.getItem(KEY)) || []).length; } catch (e) { return 0; }
  }
  function zeichne() {
    var n = anzahl();
    document.querySelectorAll('[data-veron-wish-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
    });
  }
  document.addEventListener('veron:wishlist:change', zeichne);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', zeichne);
  } else {
    zeichne();
  }
})();
